module.exports = __webpack_public_path__ + "static/7-a76b42f121a5da423d34d31ab7fd6743.png";